export default __webpack_public_path__ + "static/media/medicalOfficeImage.45a39a72.png";